import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Cookie } from '../../utils/cookie';


export class CanadaPostAddressBase {
    protected autoCompleteAddressRetrieveUrl =
        'https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Retrieve/v2.10/json3.ws?';
    protected autoCompleteAddressFindUrl =
        'https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3.ws?';

    protected maxSuggestions = 7;
    protected maxResults = 10;
    protected language = 'en';

    protected findQuerySize: string = '&MaxSuggestions=' + this.maxSuggestions + '&MaxResults=' + this.maxResults;

    constructor() {}
static ctorParameters() { return [  ]; }}


export class CanadaPostAddress_CreateAccount extends CanadaPostAddressBase {
    constructor(private http: Http) {
        super();
        this.language = new Cookie().ApiLanguage;
    }

    retrieve(addressId: string) {
        const query =
            this.autoCompleteAddressRetrieveUrl +
            'Key=' +
            (<any>window).autoCompleteKey +
            '&LanguagePreference=' +
            this.language +
            '&Id=' +
            addressId;
        return this.http.get(query);
    }

    find(searchTerm: string, lastId = '') {
        let query =
            this.autoCompleteAddressFindUrl +
            'Key=' +
            (<any>window).autoCompleteKey +
            '&LanguagePreference=' +
            this.language +
            '&SearchTerm=' +
            searchTerm +
            '&Country=CAN' +
            this.findQuerySize;
        if (lastId != undefined && lastId != '') {
            query = query + '&LastId=' + lastId;
        }
        return this.http.get(query);
    }
}(CanadaPostAddress_CreateAccount as any).ctorParameters = function () { return [ { type: Http } ]; }


export class CanadaPostAddress_BillingAddress extends CanadaPostAddressBase {
    constructor(private http: Http) {
        super();
        this.language = new Cookie().ApiLanguage;
    }

    retrieve(addressId: string) {
        const query =
            this.autoCompleteAddressRetrieveUrl +
            'Key=' +
            (<any>window).autoCompleteKey +
            '&LanguagePreference=' +
            this.language +
            '&Id=' +
            addressId;
        return this.http.get(query);
    }

    find(searchTerm: string, lastId = '') {
        let query =
            this.autoCompleteAddressFindUrl +
            'Key=' +
            (<any>window).autoCompleteKey +
            '&LanguagePreference=' +
            this.language +
            '&SearchTerm=' +
            searchTerm +
            '&Country=CAN' +
            this.findQuerySize;
        if (lastId != undefined && lastId != '') {
            query = query + '&LastId=' + lastId;
        }
        return this.http.get(query);
    }
}(CanadaPostAddress_BillingAddress as any).ctorParameters = function () { return [ { type: Http } ]; }


export class CanadaPostAddress_ShippingAddress extends CanadaPostAddressBase {
    constructor(private http: Http) {
        super();
        this.language = new Cookie().ApiLanguage;
    }

    retrieve(addressId: string) {
        const query =
            this.autoCompleteAddressRetrieveUrl +
            'Key=' +
            (<any>window).autoCompleteKey +
            '&LanguagePreference=' +
            this.language +
            '&Id=' +
            addressId;
        return this.http.get(query);
    }

    find(searchTerm: string, lastId = '') {
        let query =
            this.autoCompleteAddressFindUrl +
            'Key=' +
            (<any>window).autoCompleteKey +
            '&LanguagePreference=' +
            this.language +
            '&SearchTerm=' +
            searchTerm +
            '&Country=CAN' +
            this.findQuerySize;
        if (lastId != undefined && lastId != '') {
            query = query + '&LastId=' + lastId;
        }
        return this.http.get(query);
    }
}(CanadaPostAddress_ShippingAddress as any).ctorParameters = function () { return [ { type: Http } ]; }


export class CanadaPostAddress_CheckoutBillingShipping extends CanadaPostAddressBase {
    constructor(private http: Http) {
        super();
        this.language = new Cookie().ApiLanguage;
    }

    retrieve(addressId: string) {
        const query =
            this.autoCompleteAddressRetrieveUrl +
            'Key=' +
            (<any>window).autoCompleteKey +
            '&LanguagePreference=' +
            this.language +
            '&Id=' +
            addressId;
        return this.http.get(query);
    }

    find(searchTerm: string, lastId = '') {
        let query =
            this.autoCompleteAddressFindUrl +
            'Key=' +
            (<any>window).autoCompleteKey +
            '&LanguagePreference=' +
            this.language +
            '&SearchTerm=' +
            searchTerm +
            '&Country=CAN' +
            this.findQuerySize;
        if (lastId != undefined && lastId != '') {
            query = query + '&LastId=' + lastId;
        }
        return this.http.get(query);
    }
}(CanadaPostAddress_CheckoutBillingShipping as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../external_api/service/canadapostaddress.service.ts